import { getModelFilter, getOption } from 'src/bff/get-marketing-code';
import { useIsComerciales } from 'src/feature-app';
import { FormDataGroup } from 'src/types';
import { isOfertasForm } from '../LeadGenericoForm';

export const getConfiguradorData = async (formData: FormDataGroup) => {
	const { fields } = formData;
	const { marketingCodeData, marketingCodeResponse } = fields;
	const isComerciales = useIsComerciales();

	if (!marketingCodeResponse) return null;
	//const price = await getPriceDataWithMarketingCode(marketingCodeResponse);

	const modelDescription =
		marketingCodeResponse?.content.consolidatedData.model_description;
	const modelCode =
		marketingCodeResponse?.content.consolidatedData.model_code.split(
			'_',
		)[1];
	const type = getOption(
		'TYPE',
		marketingCodeResponse?.content.consolidatedData.options,
	);
	const salesgroup = getOption(
		'SALESGROUP',
		marketingCodeResponse?.content.consolidatedData.options,
	);
	const salesgroupCode = salesgroup?.code.replace('SALESGROUP:', '');
	const equipmentLine = getModelFilter(
		'EquipmentLine',
		marketingCodeResponse?.content.consolidatedData.meta.modelFilter,
	);

	const fuelTypeFilter = getModelFilter(
		'FuelType',
		marketingCodeResponse?.content.consolidatedData.meta.modelFilter,
	);
	let fuelType =
		modelDescription.includes('ID.') || modelDescription.includes('e-')
			? 'Electric'
			: 'Combustion';
	if (fuelTypeFilter?.text == 'H\u00edbrido enchufable') fuelType = 'Hybrid';
	if (fuelTypeFilter?.text == 'El\u00e9ctrico') fuelType = 'Electric';

	const configuradorData = {
		'fields[VEH_INTEREST_ID]': isComerciales
			? `${modelCode}_${salesgroupCode}`
			: modelCode,
		'fields[VEH_INTEREST_MODEL]': modelDescription,
		'fields[VEH_INTEREST_SALESGROUP]': salesgroup?.description,
		'fields[VEH_INTEREST_SALESGROUP_ID]': salesgroupCode,
		'fields[VEH_INTEREST_TRIM_LINE]': equipmentLine?.text,
		'fields[VEH_INTEREST_FUEL]': fuelType,
		'fields[VEH_INTEREST_DETAILS]': type?.description,
		'fields[VEH_INTEREST_CONFIGURATION_CODE]':
			marketingCodeData?.marketingCode
				? marketingCodeData?.marketingCode
				: marketingCodeResponse?.params?.marketingCode,
		// 'fields[VEH_INTEREST_MORE_INFO]': "Color pintura exterior: " + marketingCodeResponse?.exterior?.name, // Pendiente recuperar color exterior
		// 'fields[VEH_INTEREST_OFFER_PRICE]': price?.body?.amount ? `Precio final de la configuración: ${price?.body?.amount}Eur` : undefined,
	};

	// Si es un form de ofertas no es relevante el precio de la configuración ni su Marketing Code
	if (isOfertasForm(fields.formName)) {
		delete configuradorData['fields[VEH_INTEREST_CONFIGURATION_CODE]'];
		// delete configuradorData['fields[VEH_INTEREST_OFFER_PRICE]'];
	}

	return configuradorData;
};
